export function BookingCta() {
  return (
    <section className="booking-cta" aria-labelledby="booking-cta-title">
      <div>
        <p className="eyebrow">Bring ancient wisdom into modern life</p>
        <h2 id="booking-cta-title">Create a conversation that keeps moving.</h2>
      </div>
      <a className="button button--light" href="/contact">Book Christina</a>
    </section>
  );
}
